var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDelete32Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1798 15H12.9131V20.3333H15.1798V15Z",
    fill: "#6A7081"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1798 15H16.9131V20.3333H19.1798V15Z",
    fill: "#6A7081"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7135 9.53255H20.0468V8.13249C20.0451 7.62028 19.8408 7.12961 19.4786 6.76742C19.1164 6.40523 18.6257 6.20098 18.1135 6.19922H13.9335C13.4208 6.19922 12.929 6.40289 12.5664 6.76546C12.2039 7.12803 12.0002 7.61974 12.0002 8.13249V9.53255H7.3335V11.7992H8.20016V22.266C8.20193 23.2025 8.57475 24.1001 9.237 24.7624C9.89925 25.4246 10.7969 25.7974 11.7335 25.7992H20.2668C21.2034 25.7974 22.1011 25.4246 22.7633 24.7624C23.4256 24.1001 23.7984 23.2025 23.8002 22.266V11.7992H24.6668L24.7135 9.53255ZM14.2935 8.46582H17.8068V9.53255H14.2935V8.46582ZM21.5802 22.266C21.5802 22.6019 21.4467 22.9241 21.2092 23.1616C20.9716 23.3992 20.6494 23.5326 20.3135 23.5326H11.7802C11.4442 23.5326 11.122 23.3992 10.8845 23.1616C10.647 22.9241 10.5135 22.6019 10.5135 22.266V11.7992H21.5802V22.266Z",
    fill: "#6A7081"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete32Line);
export default __webpack_public_path__ + "static/media/icon_delete_32_line.2359d394205f91f62cb19daa19429113.svg";
export { ForwardRef as ReactComponent };